const cph_get_staff_issues_api = process.env.REACT_APP_API_CPH_GET_STAFF_ISSUES ?? '';
const cph_get_user_issues_api = process.env.REACT_APP_API_CPH_GET_USER_ISSUES ?? '';
const cph_get_issue_api = process.env.REACT_APP_API_CPH_GET_ISSUE ?? '';
const cph_add_comment_api = process.env.REACT_APP_API_CPH_ADD_COMMENT ?? '';
const cph_add_file_api = process.env.REACT_APP_API_CPH_ADD_FILE ?? '';
const cph_delete_file_api = process.env.REACT_APP_API_CPH_DELETE_FILE ?? '';
const cph_get_priorities_api = process.env.REACT_APP_API_CPH_GET_PRIORITIES ?? '';
const cph_set_priority_api = process.env.REACT_APP_API_CPH_SET_PRIORITY ?? '';
const cph_assign_staff_api = process.env.REACT_APP_API_CPH_ASSIGN_STAFF ?? '';
const cph_modify_title_api = process.env.REACT_APP_API_CPH_MODIFY_TITLE ?? '';
const cph_complete_issue_api = process.env.REACT_APP_API_CPH_COMPLETE_ISSUE ?? '';
const cph_close_issue_api = process.env.REACT_APP_API_CPH_CLOSE_ISSUE ?? '';
const cph_get_file_api = process.env.REACT_APP_API_CPH_GET_FILE ?? '';

export function constructResourceUrl(
    uri: string,
    replacements: Array<[string, string]>
    ): string {
    let str = uri;
    for (const [oldValue, newValue] of replacements) {
        str = str.replace(oldValue, newValue);
    }
    return str;
}

export const getUri_GetAll = (isStaff: boolean, customerKey: string) => {
    if (isStaff) {
        return `${cph_get_staff_issues_api}`;
    } else {
        const url = constructResourceUrl(cph_get_user_issues_api, [
            ["{customerKey}", customerKey]
        ]);
        return `${url}`;
    }
};

export const getUri_GetIssue = (issueKey: string) => {
    const url = constructResourceUrl(cph_get_issue_api, [
        ["{issueKey}", issueKey]
    ]);
    return `${url}`;
};

export const getUri_GetPriorities = () => {
    const url = constructResourceUrl(cph_get_priorities_api, []);
    return `${url}`;
};

export const getUri_SetPriority = (issueKey: string, priorityKey: string) => {
    const url = constructResourceUrl(cph_set_priority_api, [
        ["{issueKey}", issueKey],
        ["{priorityKey}", priorityKey]
    ]);
    return `${url}`;
};

export const getUri_AddComment = (issueKey: string, customerKey: string) => {
    const url = constructResourceUrl(cph_add_comment_api, [
        ["{issueKey}", issueKey],
        ["{customerKey}", customerKey]
    ]);
    return `${url}`;
};

export const getUri_AddFile = (issueKey: string, reporterAapId: number, customerKey: string, isStaff: boolean) => {
    const url = constructResourceUrl(cph_add_file_api, [
        ["{issueKey}", issueKey],
        ["{aapId}", reporterAapId.toString()],
        ["{customerKey}", customerKey],
        ["{isStaff}", isStaff.toString()]
    ]);
    return `${url}`;
};

export const getUri_DeleteFile = (customerKey: string) => {
    const url = constructResourceUrl(cph_delete_file_api, [
        ["{customerKey}", customerKey]
    ]);
    return `${url}`;
};

export const getUri_AssignStaff = (issueKey: string, aapId: string) => {
    const url = constructResourceUrl(cph_assign_staff_api, [
        ["{issueKey}", issueKey],
        ["{aapId}", aapId]
    ]);
    return `${url}`;
};

export const getUri_ModifyTitle = (issueKey: string) => {
    const url = constructResourceUrl(cph_modify_title_api, [
        ["{issueKey}", issueKey]
    ]);
    return `${url}`;
};

export const getUri_CompleteIssue = (issueKey: string, staffCstKey: string) => {
    const url = constructResourceUrl(cph_complete_issue_api, [
        ["{issueKey}", issueKey],
        ["{staffCstKey}", staffCstKey]
    ]);
    return `${url}`;
};

export const getUri_CloseIssue = (issueKey: string, staffCstKey: string) => {
    const url = constructResourceUrl(cph_close_issue_api, [
        ["{issueKey}", issueKey],
        ["{staffCstKey}", staffCstKey]
    ]);
    return `${url}`;
};

export const getUri_GetFile = () => {
    return `${cph_get_file_api}`;
};